/**
 * @readonly
 * @typedef {Object} VehicleGenerationModel
 * @property {string} DESCRIPTION - The vehicle's generation description
 * @property {string} GENERATION_ID -  The ID of the car generation
 * @property {string} GENERATION_NO - The vehicle's generation number
 * @property {string} MAKE - The vehicle's make
 * @property {string} VERSION -  The vehicle's generation version
 */
export const VehicleGenerationModel = {
    DESCRIPTION: 'description',
    GENERATION_ID: 'generationId',
    GENERATION_NO: 'generationNo',
    MAKE: 'make',
    VERSION: 'version'
}
